import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { GeneralPageForm } from '../../forms/GeneralPageForm'
import { UseGetWorkspaceAmazon } from '../../hooks/useGetWorkspaceAmazon'
import { InventoryConnectionPage } from '../InventoryConnectionPage'
import { AmazonTabs } from './types'

type Props = {
  workspaceAmazon: UseGetWorkspaceAmazon['workspaceAmazon']
}

export const useTabs = ({ workspaceAmazon }: Props): Tab<AmazonTabs>[] => {
  const { t } = useTranslation('features/globalSetup/amazon')

  const generalTab: Tab<AmazonTabs> = {
    authorized: 'GlobalSetupPage-amazon-general',
    element: 'general',
    label: t('tabs.general'),
    page: <GeneralPageForm />,
  }

  const inventoryConnectionTab: Tab<AmazonTabs> = {
    authorized: 'GlobalSetupPage-amazon-inventory-connection',
    element: 'inventory-connection',
    label: t('tabs.inventoryConnection'),
    page: <InventoryConnectionPage />,
  }

  if (workspaceAmazon === undefined) {
    return []
  } else if (workspaceAmazon === null) {
    return [generalTab]
  } else {
    return [generalTab, inventoryConnectionTab]
  }
}
